const config = {
  Auth: {
    userPoolId: 'eu-west-1_IbtW0yyjh',
    userPoolWebClientId: '7gulrcakj5qtosh9g0829df8g3',
  },
  enableSelfSignup: false, // 1 for enable 0 for disable
  apiUrl: 'https://api.dev.lingualist.fathominnovation.com',
  awsTranslateCredentials: {
    accessKeyId: 'AKIAYJ2JVR4WTBOK7ZUL',
    secretAccessKey: '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',
  },
  languages: [
    { code: 'da', name: 'Dansk', enabled: false },
    { code: 'de', name: 'Deutsh', enabled: false },
    { code: 'en', name: 'English', enabled: false },
    { code: 'es', name: 'Español', enabled: false },
    { code: 'fr', name: 'Français', enabled: false },
    { code: 'zh', name: 'Chinese', enabled: false },
    { code: 'ar', name: 'Arabic', enabled: false },
  ],
};

export default config;
